$('.js-reviewSlider').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    nextArrow: '<div type="button" class="slick-next"></div>',
    prevArrow: '<div type="button" class="slick-prev"></div>',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
    ]
});